export const termsLastUpdated = '2026-09-07'
export const privacyLastUpdated = '2026-09-28'
